import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AlertTriangle } from "lucide-react";

export function StockAlerts({ alerts }) {
  if (!alerts.length) return null;

  return (
    <Card className="border-yellow-500/50 bg-yellow-500/5">
      <CardContent className="py-3 px-4 flex items-center gap-3">
        <AlertTriangle className="w-5 h-5 text-yellow-500 flex-shrink-0" />
        <div className="flex flex-wrap gap-2">
          {alerts.map(a => (
            <Badge key={a.id} variant="outline" className="text-yellow-500 border-yellow-500/50">
              {a.name}: {a.current_quantity} {a.unit} (min: {a.min_quantity})
            </Badge>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
